export interface SortFilterOption<T extends string> {
  value: T
  label: string
  enabled: boolean
}

export interface PaymentSortFilterType {
  sortOption: SortFilterOption<server.dto.PaymentSort>
}

export const DefaultPaymentSortFilter: server.dto.PaymentSort =
  "receivedOnDesc";

export const PaymentSortOptions: Array<SortFilterOption<server.dto.PaymentSort>> = [
  {
    value: "receivedOnDesc",
    label: RESX.Payment.ReceivedOn,
    enabled: true
  },
  {
    value: "amountAsc",
    label: RESX.Financial.Amount,
    enabled: true
  },
  {
    value: "companyAsc",
    label: RESX.Payment.ReceivedFrom,
    enabled: true
  }
];

export const getSortOption = (value: server.dto.PaymentSort) => {
  return PaymentSortOptions.find((s) => s.value === value);
};

export const initialPaymentSortFilter: PaymentSortFilterType = {
  sortOption: getSortOption(DefaultPaymentSortFilter)
};
